export class guage {
    id: number | undefined;
    name: string | undefined;
    value: number | undefined;
}
export class graphData<T> {
    name: string | undefined;
    data: T[] | [] = [];
}
export class kosten {
    time: Date | undefined;
    value: number | undefined;
    description: string | undefined;
}

export class durchsatz extends kosten {
}

export class störfälle {
    id: number | undefined;
    description: string | undefined;
    status: string | undefined;
}